export default {"src":"/_next/static/media/barrier-own.8082cfc5.svg","height":100,"width":100};